module.exports = __webpack_public_path__ + "img/comment.4158d743.svg";